module.exports = __webpack_public_path__ + "public/img/jl.f14b9c12.png";